import * as Yup from 'yup'

const fastSellProductRejectFormSchema = Yup.object().shape({
  status_reject_reason: Yup.string().required(
    'Reject reason harus diisi apabila ingin reject product'
  ),
  ops_notes: Yup.string().required(
    'Interna Notes harus diisi apabila ingin reject product'
  )
})

export default fastSellProductRejectFormSchema
